<template>
  <div class="hg-nav">
    <div class="hg-nav-left">
      <img
        src="../../../assets/logo.png"
        class="nav-logo">
      <p
        :class="['left-btn', activeTab === '' ? 'active-tab' : '']"
        @click="handleTabClick('')">
        首页
      </p>
      <p
        :class="['left-btn', activeTab === 'space' ? 'active-tab' : '']"
        @click="handleTabClick('space')">
        空间
      </p>
      <p
        :class="['left-btn', activeTab === 'member' ? 'active-tab' : '']"
        @click="handleTabClick('member')">
        会员
      </p>
      <p
        :class="['left-btn', activeTab === 'choice' ? 'active-tab' : '']"
        @click="handleTabClick('choice')">
        精选报告
      </p>
    </div>
    <div class="hg-nav-right">
      <div
        class="right-btn"
        @click="$store.commit('SET_APPLY_SHOW', true)">
        会员申请
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeTab: ''
    }
  },
  mounted () {
    const tab = window.location.pathname.split('/')[1]
    this.activeTab = tab
  },
  methods: {
    handleTabClick (tab) {
      this.activeTab = tab
      this.$router.push(`/${tab}`)
    }
  }
}
</script>

<style lang="scss">
  @import '@/style/var/color.scss';
  .hg-nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 18px 20.834% 14px 18.854%;
    font-size: 16px;
    color: #333;
    .hg-nav-left {
      height: 100%;
      display: flex;
      align-items: center;
      .nav-logo {
        width: 20px;
        height: 40px;
      }
      .left-btn {
        margin-left: 46px;
        color: #333;
        cursor: pointer;
        &:first-of-type {
          margin-left: 60px;
        }
        &:hover {
          color: $main-color;
        }
      }
      .active-tab {
        color: $main-color;
      }
    }
    .hg-nav-right {
      .right-btn {
        cursor: pointer;
        &:hover {
          color: $main-color;
        }
      }
    }
  }
</style>
